import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Background from "./Background";
import Layer from "./Layer";
import "./Create.css";
import ColorPicker from "mb-react-color-picker";
import Menu2 from '../../Menu/Menu2'
import { mockProducts } from '../../mockData';
import DesignModeContext from '../../DesignModeContext';
import html2canvas from 'html2canvas';

class Create extends Component {
  static contextType = DesignModeContext;

  constructor(props) {
    super();
    this.state = {
      Product: {
        Id: 1,
        Name: "Heart Pop Socket",
        PictureUrl1: "/media/HeartPopSocket1.jpg",
        PictureUrl2: "/media/HeartPopSocket2.png",
        PictureUrl3: "/media/HeartPopSocket2.png"
      },
      Products: [],
      ProductComponents: [],
      DashboardWidth: 0,
      DashboardLeft: 0,
      DashboardTop: 0,
      ProductComponents: [<option>Loading...</option>],
      TopMargin: 0,
      DashboardWidth: "60%",
      DashboardMargin: "0 0",
      BackgroundColor: "rgba(255, 255, 255, 0)",
      ShowBGColor: false,
      Inputs: [],
      parentUpdate: false,
      grid: false,
      gridPic: "",
      safetyLine: true
    };
  }

  getProducts = async () => {
    const { isDesignMode } = this.context;
    
    if (isDesignMode) {
      // Use mock data in design mode
      let tempProducts = mockProducts;
      tempProducts.key = tempProducts.Name;
      let productsArray = [];
      for (let i = 0; i < tempProducts.length; i++) {
        productsArray.push(
          <option key={i} value={tempProducts[i].Name}>{tempProducts[i].Name}</option>
        );
      }
      this.setState({ Products: tempProducts });
      this.setState({ ProductComponents: productsArray });
      this.handleProduct(tempProducts[0].Name);

      if (this.props.match.params.ID){
        console.log(this.props.match.params)
        this.handleProduct(this.props.match.params.ID)
      }
    } else {
      // Fetch from API in live mode
      let tempProducts = {};
      await axios({
        url: "https://api.caigoycreations.com/products/getproducts?IsActive=true&IsSoldOut=false",
        method: "get"
      }).then(
        res => {
          let tempProducts = res.data.data;
          tempProducts.key = tempProducts.Name;
          let productsArray = [];
          for (let i = 0; i < tempProducts.length; i++) {
            productsArray.push(
              <option key={i} value={tempProducts[i].Name}>{tempProducts[i].Name}</option>
            );
          }
          this.setState({ Products: tempProducts });
          this.setState({ ProductComponents: productsArray });
          this.handleProduct(tempProducts[0].Name);

          if (this.props.match.params.ID){
            console.log(this.props.match.params)
            this.handleProduct(this.props.match.params.ID)
          }
        },
        err => {
          alert("connection to api failed, please upload again" + err.data);
          console.log(err.data);
        }
      );
    }
  };

  handleGridPic = e => {
    if (e == "None") {
      this.setState({ grid: false, gridPic: "" });
    }
    if (e == 3) {
      this.setState({
        grid: true,
        gridPic: "https://caigoycreations.com/images/3x3.png"
      });
    }
    if (e == 4) {
      this.setState({
        grid: true,
        gridPic: "https://caigoycreations.com/images/4x4.png"
      });
    }
    if (e == 5) {
      this.setState({
        grid: true,
        gridPic: "https://caigoycreations.com/images/5x5.png"
      });
    }
  };

  handleProduct = e => {
    if (e) {
      console.log(e);
      let tempProduct = {};
      for (let i = 0; i < this.state.Products.length; i++) {
        if (this.state.Products[i].Name == e) {
          this.setState({ Product: this.state.Products[i] });
        }
      }
    } else {
      this.setState({
        Product: {
          Id: -1,
          Name: "",
          PictureUrl1: "",
          PictureUrl2: ""
        }
      });
    }
  };

  checkSafetyLine = e => {
    console.log(e.target.checked)
    if (!e.target.checked){
      //alert('on')
      this.setState({safetyLine: true})
    }
    else {
      //alert('off')
      this.setState({safetyLine: false})
    }

  }

  backgroundColorChange = e => {
    this.setState({
      BackgroundColor: e
    });
  };

  toggleShowBGColor = () => {
    this.setState({ ShowBGColor: !this.state.ShowBGColor });
  };

  addLayer = LayerType => {
    let tempInputs = this.state.Inputs;
    for (let i = 0; i < this.state.Inputs.length; i++) {
      tempInputs[i].Visible = false;
      tempInputs[i].Display = "none";
    }
    let index = this.state.Inputs.length;
    
    // Calculate center of the canvas (not screen)
    const canvasLeft = document.body.clientWidth > 600 
      ? document.body.clientWidth / 2 
      : document.body.clientWidth / 2 - 150;
    const canvasTop = document.body.clientWidth > 600 
      ? 50 
      : 10;
    const canvasSize = document.body.clientWidth > 600 
      ? document.body.clientWidth / 2 
      : 300;
    
    // Position layer in center of canvas
    const centerLeft = canvasLeft + canvasSize / 2 - 100; // -100 to center a 200px wide layer
    const centerTop = canvasTop + canvasSize / 2 - 100;   // -100 to center a 200px tall layer
    
    if (LayerType == "Text") {
      tempInputs.push({
        //position info
        Left: centerLeft,
        Top: centerTop,
        Width: 200,
        Height: 200,
        RotateAngle: 0,

        Visible: true,

        //text info
        LayerType: "Text",
        Text: "",
        FontStyle: "normal",
        FontSize: 50,
        TextColor: "rgba(0, 0, 0, 1)",
        ShowTextColor: false,
        TextOpacity: 100,
        Font: "Arial",
        TextAlign: "center",
        Bold: false,
        FontWeight: "normal",
        UnderLine: false,
        TextDecoration: "none",
        Italic: false,
        LineSpace: 100,
        FontStyle: "normal",
        TextOpacity: 100,

        //background info
        BackgroundColor: "rgba(255, 255, 255, 0)",
        ShowLayerColor: false,
        Opacity: 0,

        //Picture info
        IsImage: true,
        ImageUrl: "",
        Ratio: true,
        PictureOpacity: 100,

        //display
        Display: "flex",

        //border info
        BorderThickness: 0,
        BorderColor: "rgba(0, 0, 0, 1)",
        ShowBorderColor: false
      });
    }

    this.setState({ Inputs: tempInputs });
    //window.scrollBy(0, window.innerHeight);
  };


  handleSizeIncrease = i => {
    let tempInputs = this.state.Inputs;
    tempInputs[i].Left -= 2*(document.body.clientWidth/200);
    tempInputs[i].Top -= 2*document.body.clientWidth/200;
    tempInputs[i].Width += 2*(document.body.clientWidth/100);
    tempInputs[i].Height += 2*document.body.clientWidth/100;
    tempInputs[i].ParentUpdate = true;
    this.setState({Inputs:tempInputs});
  }

  handleSizeDecrease = i => {
    let tempInputs = this.state.Inputs;
    tempInputs[i].Left += (2*document.body.clientWidth/200);
    tempInputs[i].Top += 2*document.body.clientWidth/200;
    tempInputs[i].Width -= (2*document.body.clientWidth/100);
    tempInputs[i].Height -= 2*document.body.clientWidth/100;
    tempInputs[i].ParentUpdate = true;
    this.setState({Inputs:tempInputs});
  }


  handleHighlightOn = el => {
    let tempInputs = this.state.Inputs;
    for (let i = 0; i < this.state.Inputs.length; i++) {
      tempInputs[i].highlight = false;
    }
    tempInputs[el].highlight = true;
    this.setState({ Inputs: tempInputs });
  };

  handleHighlightOff = el => {
    let tempInputs = this.state.Inputs;
    for (let i = 0; i < this.state.Inputs.length; i++) {
      tempInputs[i].highlight = false;
    }
    this.setState({ Inputs: tempInputs });
  };

  //toggle button
  handleSetVisible = el => {
    let tempInputs = this.state.Inputs;
    let check = this.state.Inputs[el].Visible;
    for (let i = 0; i < this.state.Inputs.length; i++) {
      tempInputs[i].Visible = false;
      tempInputs[i].Display = "none";
    }
    tempInputs[el].Visible = !check;
    if (tempInputs[el].Visible) {
      tempInputs[el].Display = "flex";
    } else {
      tempInputs[el].Display = "none";
    }
    this.setState({ Inputs: tempInputs });
  };

  handleTextChange = (el, e) => {
    let tempInputs = this.state.Inputs;
    tempInputs[el].Text = e;
    this.setState({ Inputs: tempInputs });
  };

  handleFontFamily = (el, e) => {
    let tempInputs = this.state.Inputs;
    tempInputs[el].Font = e;
    this.setState({ Inputs: tempInputs });
  };

  handleFontSize = (el, e) => {
    let tempInputs = this.state.Inputs;
    tempInputs[el].FontSize = e;
    this.setState({ Inputs: tempInputs });
  };

  handleTextColorChange = (el, e) => {
    console.log(e);
    let tempInputs = this.state.Inputs;
    tempInputs[el].TextColor = e;
    this.setState({ Inputs: tempInputs });
  };

  toggleTextColorChange = el => {
    let tempInputs = this.state.Inputs;
    tempInputs[el].ShowTextColor = !tempInputs[el].ShowTextColor;
    this.setState({ Inputs: tempInputs });
  };

  handleTextAlign = (el, e) => {
    let tempInputs = this.state.Inputs;
    tempInputs[el].TextAlign = e;
    this.setState({ Inputs: tempInputs });
    console.log(e);
  };

  handleBold = (el, e) => {
    let tempInputs = this.state.Inputs;
    if (!tempInputs[el].Bold) {
      tempInputs[el].FontWeight = "bold";
    } else {
      tempInputs[el].FontWeight = "normal";
    }
    tempInputs[el].Bold = !tempInputs[el].Bold;
    this.setState({ Inputs: tempInputs });
  };

  handleUnderline = (el, e) => {
    let tempInputs = this.state.Inputs;
    if (!tempInputs[el].UnderLine) {
      tempInputs[el].TextDecoration = "underline";
    } else {
      tempInputs[el].TextDecoration = "none";
    }
    tempInputs[el].UnderLine = !tempInputs[el].UnderLine;
    this.setState({ Inputs: tempInputs });
  };

  handleItalic = (el, e) => {
    let tempInputs = this.state.Inputs;
    if (!tempInputs[el].Italic) {
      tempInputs[el].FontStyle = "italic";
    } else {
      tempInputs[el].FontStyle = "normal";
    }
    tempInputs[el].Italic = !tempInputs[el].Italic;
    this.setState({ Inputs: tempInputs });
  };

  handleLineSpace = (el, e) => {
    console.log(e);
    let tempInputs = this.state.Inputs;
    tempInputs[el].LineSpace = e;
    this.setState({ Inputs: tempInputs });
  };

  handleLayerBackgroundChange = (el, e) => {
    let tempInputs = this.state.Inputs;
    tempInputs[el].BackgroundColor = e;
    this.setState({ Inputs: tempInputs });
  };

  toggleShowLayerColor = el => {
    let tempInputs = this.state.Inputs;
    tempInputs[el].ShowLayerColor = !tempInputs[el].ShowLayerColor;
    this.setState({ inputs: tempInputs });
  };

  handleLayerBackgroundOpacity = (el, e) => {
    let tempInputs = this.state.Inputs;
    tempInputs[el].Opacity = e;
    this.setState({ Inputs: tempInputs });
  };

  handlerLayerTextOpacity = (el, e) => {
    let tempInputs = this.state.Inputs;
    tempInputs[el].TextOpacity = e;
    this.setState({ Inputs: tempInputs });
  };

  handleRatioCheckbox = (el, e) => {
    let tempInputs = this.state.Inputs;
    tempInputs[el].Ratio = !this.state.Inputs[el].Ratio;
    this.setState({ Inputs: tempInputs });
  };

  handleImageUrl = (el, e) => {
    let tempInputs = this.state.Inputs;
    tempInputs[el].ImageUrl = e;
    this.setState({ Inputs: tempInputs });
  };

  handleImageUpload = async (el, e) => {
    const { isDesignMode } = this.context;
    let file = e.target.files[0];
    
    if (isDesignMode) {
      // In design mode, use local file URL
      const reader = new FileReader();
      reader.onload = (event) => {
        let tempInputs = this.state.Inputs;
        tempInputs[el].ImageUrl = event.target.result;
        this.setState({ Inputs: tempInputs });
      };
      reader.readAsDataURL(file);
      
      if (file.size > 300000) {
        alert("Large file detected!");
      }
    } else {
      // In live mode, upload to API
      let formData = new FormData();
      formData.append("file", file);
      await axios({
        url: "https://api.caigoycreations.com/pictures/upload",
        method: "post",
        headers: {
          "content-type": "multipart/form-data"
        },
        data: formData
      }).then(
        res => {
          let tempInputs = this.state.Inputs;
          tempInputs[el].ImageUrl = res.data.data;
          this.setState({ Inputs: tempInputs });
        },
        err => {
          alert("file upload failed.  please upload again.  " + err);
          alert(err.data);
          console.log(err);
        }
      );
      if (file.size > 300000) {
        alert("Large file, please wait for photo to upload!");
      }
    }
  };

  handlePictureOpacity = (el, e) => {
    let tempInputs = this.state.Inputs;
    if (e < 0){
      e = 0;
    }
    if (e > 100){
      e = 100;
    }
    tempInputs[el].PictureOpacity = e;
    this.setState({ Inputs: tempInputs });
    console.log(this.state.Inputs);
  };

  handleBorderThickness = (el, e) => {
    let tempInputs = this.state.Inputs;
    if (e < 0){
      e = 0;
    }
    if (e > 100){
      e = 100;
    }
    tempInputs[el].BorderThickness = e;
    this.setState({ Inputs: tempInputs });
  };

  handleBorderColor = (el, e) => {
    let tempInputs = this.state.Inputs;
    tempInputs[el].BorderColor = e;
    this.setState({ Inputs: tempInputs });
  };

  toggleShowBorderColor = el => {
    let tempInputs = this.state.Inputs;
    tempInputs[el].ShowBorderColor = !tempInputs[el].ShowBorderColor;
    this.setState({ Inputs: tempInputs });
  };

  handleMoveLayerUp = el => {
    if (el > 0) {
      // let tempInputs = this.state.Inputs;
      let tempInputs = this.state.Inputs;
      let temp = this.state.Inputs[el];
      tempInputs[el] = this.state.Inputs[el - 1];
      tempInputs[el - 1] = temp;
      tempInputs[el].ParentUpdate = true;
      tempInputs[el - 1].ParentUpdate = true;
      this.setState({ Inputs: tempInputs});
    }
  };

  handleMoveLayerDown = el => {
    if (el < this.state.Inputs.length - 1) {
      // let tempInputs = this.state.Inputs;
      let tempInputs = this.state.Inputs;
      let temp = this.state.Inputs[el];
      tempInputs[el] = this.state.Inputs[el + 1];
      tempInputs[el + 1] = temp;
      tempInputs[el].ParentUpdate = true;
      tempInputs[el+1].ParentUpdate = true;
      this.setState({ Inputs: tempInputs});
    }
  };

  handleDuplicateLayer = el => {
    let tempInputs = [];
    for (let i = 0; i < this.state.Inputs.length; i++) {
      tempInputs.push(this.state.Inputs[i]);
      if (i == el) {
        alert(i);
        let tempInput = (tempInput = this.state.Inputs[i]);
        tempInput.Visible = false;
        tempInput.Display = "none";
        tempInputs.push(tempInput);
      }
    }
    this.setState({ Inputs: tempInputs });
  };

  handleDeleteLayer = el => {
    let tempInputs = [];
    for (let i = 0; i < this.state.Inputs.length; i++) {
      if (el != i) {
        let tempInput = this.state.Inputs[i];
        tempInputs.push(tempInput);
      }
    }
    this.setState({ Inputs: tempInputs });
  };

  //Control Settings
  displayInputTabs = () => {
    let tempInputArray = [];
    for (let i = 0; i < this.state.Inputs.length; i++) {
      //Text Layer Type
      if (this.state.Inputs[i].LayerType == "Text") {
        tempInputArray.push(
          <div className="InputTab">
            <div
              onMouseOver={() => {
                this.handleHighlightOn(i);
                //alert("mouse over");
              }}
              onMouseLeave={() => {
                this.handleHighlightOff(i);
                //alert("mouse off");
              }}
            >
              <div className='Layer-Title'>
                <label>Layer {i+1 + ' '}</label>
                <button
                  onClick={() => {
                    this.handleSetVisible(i);
                  }}
                >
                  {this.state.Inputs[i].Visible &&
                    <div>Hide Layer Controls</div>
                  }
                  {!this.state.Inputs[i].Visible &&
                    <div>Show Layer Controls</div>
                  }
                </button>
              </div>
            </div>

            <div
              className="InputControls"
              style={{
                display: this.state.Inputs[i].Display
              }}
            >

              <br />
              
              <div className='SizeBox'>
                <label>Increase/Decrease Layer Size</label>
                <br />

                <button 
                  className='SizeButton'
                  onClick={() => {
                  this.handleSizeDecrease(i)
                }}>
                  -
                </button>
              {' '}
                <button 
                  className='SizeButton'
                  onClick={() =>{
                  this.handleSizeIncrease(i)
                }}
                >
                  +
                </button>
              </div>

              <br />
              <div className="PictureBox">
                <label>Picture</label>
                <input
                  type="file"
                  onChange={e => {
                    this.handleImageUpload(i, e);
                  }}
                  accept="image/*"
                />
                <br />
                <br />
                <div>
                  <label>Maintain Picture Ratio</label>
                  <input
                    type="checkbox"
                    checked={this.state.Inputs[i].Ratio}
                    onChange={e => {
                      this.handleRatioCheckbox(i, e);
                    }}
                  />
                </div>
                <br />
                <div>
                  <label>Picture Opacity %</label>
                  <br />
                  <input
                    type="number"
                    value={this.state.Inputs[i].PictureOpacity}
                    onChange={e => {
                      this.handlePictureOpacity(i, e.target.value);
                    }}
                  />{" "}
                  <button
                    className='SizeButton'
                    onClick={() => {
                      this.handlePictureOpacity(
                        i,
                        this.state.Inputs[i].PictureOpacity - 1
                      );
                    }}
                  >
                    -
                  </button>{" "}
                  <button
                    className='SizeButton'
                    onClick={() => {
                      this.handlePictureOpacity(
                        i,
                        this.state.Inputs[i].PictureOpacity + 1
                      );
                    }}
                  >
                    +
                  </button>
                </div>
              </div>
              <br />
              <div className="BorderBox">
                <label>Border Thickness</label>
                <br />
                <input
                  type="number"
                  value={this.state.Inputs[i].BorderThickness}
                  onChange={e => {
                    if (this.state.Inputs[i].BorderThickness <= -1){
                      this.handleBorderThickness(i, 0)
                    }
                    else if (this.state.Inputs.BorderThickness > 100){
                      this.handleBorderThickness(i, 100)
                    }
                    else {
                      this.handleBorderThickness(i, e.target.value);
                    }
                  }}
                />{" "}
                <button
                  className='SizeButton'
                  onClick={() => {
                    this.handleBorderThickness(
                      i,
                      this.state.Inputs[i].BorderThickness - 1
                    );
                  }}
                >
                  -
                </button>{" "}
                <button
                  className='SizeButton'
                  onClick={() => {
                    this.handleBorderThickness(
                      i,
                      this.state.Inputs[i].BorderThickness + 1
                    );
                  }}
                >
                  +
                </button>
                <br />
                <br />
                <label>Border Color</label>
                <br />
                <div>
                  {/*
                  <input
                    type="text"
                    value={this.state.Inputs[i].BorderColor}
                    onChange={e => {
                      this.handleBorderColor(i, e.target.value);
                    }}
                  />{" "}
                  */}
                  <button
                    className='ColorToggle'
                    onClick={() => {
                      this.toggleShowBorderColor(i);
                    }}
                  >
                    <label>Show/Hide Colors</label>
                  </button>
                </div>
                {this.state.Inputs[i].ShowBorderColor && (
                  <ColorPicker
                    color={this.state.Inputs[i].BorderColor}
                    onChange={e => {
                      this.handleBorderColor(i, e);
                    }}
                    onConfirm={e => {
                      this.handleBorderColor(i, e);
                    }}
                  />
                )}
              </div>
              <br />
              <label>Text</label>
              <br />
              <textarea
                style={{ 
                  minHeight: "50px" 
                }}
                value={this.state.Inputs[i].Text}
                onChange={e => {
                  this.handleTextChange(i, e.target.value);
                }}
              >
                {this.state.Inputs[i].Text}
              </textarea>
              <label>Font</label>
              <select
                value={this.state.Inputs[i].Font}
                onChange={e => {
                  this.handleFontFamily(i, e.target.value);
                }}
              >
                <option value="Arial" select>
                  Arial
                </option>
                <option value="Arial Black">Arial Black</option>
                <option value="Arial Narrow">Arial Narrow</option>
                <option value="Baskerville Old Face">
                  Baskerville Old Face
                </option>
                <option value="Book Antiqua">Book Antiqua</option>
                <option value="Calibri">Calibri</option>
                <option value="Calisto MT">Calisto MT</option>
                <option value="Cambria">Cambria</option>
                <option value="Candara">Candara</option>
                <option value="Century Gothic">Century Gothic</option>
                <option value="Consolas">Consolas</option>
                <option value="Copperplate Gothic Light">
                  Copperplate Gothic Light
                </option>
                <option value="Courier New">Courier New</option>
                <option value="Garamond">Garamond</option>
                <option value="Georgia">Georgia</option>
                <option value="Goudy Old Style">Goudy Old Style</option>
                <option value="Gill Sans MT">Gill Sans MT</option>
                <option value="Lucida Bright">Lucida Bright</option>
                <option value="Lucida Sans Typewriter">
                  Lucida Sans Typewriter
                </option>
                <option value="Palatino">Palatino</option>
                <option value="Papyrus">Papyrus</option>
                <option value="Brush Script MT">Brush Script</option>
                <option value="Tahoma">Tahoma</option>
                <option value="Trebuchet MS">Treuchet MS</option>
                <option value="Verdana">Verdana</option>
                <option value="Times New Roman">Times New Roman</option>
              </select>
              <div>
                <label>Text Size</label>
                <br />
                <input
                  type="number"
                  value={this.state.Inputs[i].FontSize}
                  onChange={e => {
                    this.handleFontSize(i, e.target.value);
                  }}
                  disabled={true}
                />{" "}
                <input
                  type='range'
                  min='1'
                  max='100'
                  value={this.state.Inputs[i].FontSize}
                  step='1'
                  onChange={e => {
                    if (e.target.value > 100){
                      this.handleFontSize(i, 100)
                    }
                    else if (e.target.value < 1){
                      this.handleFontSize(i, 1)
                    }
                    else {
                      this.handleFontSize(i, e.target.value)
                    }
                  }}

                />
                <button
                  className='SizeButton'
                  onClick={() => {
                    if (this.state.Inputs[i].FontSize > 1){
                      this.handleFontSize(i, this.state.Inputs[i].FontSize - 1);
                    }
                  }}
                >
                  -
                </button>{" "}
                <button
                  className='SizeButton'
                  onClick={() => {
                    if (this.state.Inputs[i].FontSize < 100){
                      this.handleFontSize(i, Number(this.state.Inputs[i].FontSize) +1);
                    }
                  }}
                >
                  +
                </button>
              </div>
              <label>Text Color</label>
              <div>
                {/*
                <input
                  type="text"
                  value={this.state.Inputs[i].TextColor}
                  onChange={e => {
                    this.handleTextColorChange(i, e.target.value);
                  }}
                />{" "}
                */}
                <button
                  className='ColorToggle'
                  onClick={() => {
                    this.toggleTextColorChange(i);
                  }}
                >
                  Show/Hide Colors
                </button>
              </div>
              {this.state.Inputs[i].ShowTextColor && (
                <ColorPicker
                  color={this.state.Inputs[i].TextColor}
                  onChange={e => {
                    this.handleTextColorChange(i, e);
                  }}
                  onConfirm={e => {
                    this.handleTextColorChange(i, e);
                  }}
                />
              )}
              
              <br />
              {/* text-align */}
              <label>Text Align</label>
              <div>
                <input
                  type="radio"
                  name="textAlign"
                  value="left"
                  onClick={e => {
                    this.handleTextAlign(i, e.target.value);
                  }}
                />{" "}
                Left
              </div>
              <div>
                <input
                  type="radio"
                  name="textAlign"
                  value="center"
                  onClick={e => {
                    this.handleTextAlign(i, e.target.value);
                  }}
                />{" "}
                Center
              </div>
              <div>
                <input
                  type="radio"
                  name="textAlign"
                  value="Right"
                  onClick={e => {
                    this.handleTextAlign(i, e.target.value);
                  }}
                />{" "}
                Right
              </div>

              <br />
              <div>
                <input
                  type="checkbox"
                  checked={this.state.Inputs[i].Bold}
                  onChange={e => {
                    this.handleBold(i, e);
                  }}
                />{" "}
                Bold
              </div>
              <div>
                <input
                  type="checkbox"
                  checked={this.state.Inputs[i].UnderLine}
                  onChange={e => {
                    this.handleUnderline(i, e);
                  }}
                />{" "}
                Underline
              </div>
              <div>
                <input
                  type="checkbox"
                  checked={this.state.Inputs[i].Italic}
                  onChange={e => {
                    this.handleItalic(i, e);
                  }}
                />{" "}
                Italic
              </div>
              <br />
              <div>
                {/*
                Line Space %
                <br />
                <input type='number'
                value={this.state.Inputs[i].LineSpace}
                onChange={e => { this.handleLineSpace(i, e.target.value)}}
                />{' '}
                <button style={{width: '25px'}} onClick={() => { this.handleLineSpace(i, this.state.Inputs[i].LineSpace-1)}}>-</button>
                {' '}
                <button style={{width: '25px'}} onClick={() => { this.handleLineSpace(i, this.state.Inputs[i].LineSpace+1)}}>+</button>
                <br />
                */}
              </div>
              <label>Layer Background Color</label>
              <br />
              <div>
                {/*
                <input
                  type="text"
                  value={this.state.Inputs[i].BackgroundColor}
                  onChange={e => {
                    this.handleLayerBackgroundChange(i, e.target.value);
                  }}
                />{" "}
                */}
                <button
                  className='ColorToggle'
                  onClick={() => {
                    this.toggleShowLayerColor(i);
                  }}
                >
                  Show/Hide Colors
                </button>
                  {' '}
                <button
                  className='colorToggle'
                  onClick={() => {
                    this.handleLayerBackgroundChange(i,'rgba(255, 255, 255, 0')
                  }}
                >
                  Clear Layer Color
                </button>
                <br />
              </div>
              {this.state.Inputs[i].ShowLayerColor && (
                <ColorPicker
                  color={'#eeeeee'}
                  onChange={e => {
                    this.handleLayerBackgroundChange(i, e);
                  }}
                  onConfirm={e => {
                    this.handleLayerBackgroundChange(i, e);
                  }}
                />
              )}
              <br />
              {/*
              Layer Opacity %
              <br />
              <div>
                <input
                  type="number"
                  value={this.state.Inputs[i].Opacity}
                  onChange={e => {
                    this.handleLayerBackgroundOpacity(i, e.target.value);
                  }}
                />{" "}
                <button
                  style={{ width: "25px" }}
                  onClick={() => {
                    this.handleLayerBackgroundOpacity(
                      i,
                      this.state.Inputs[i].Opacity - 1
                    );
                  }}
                >
                  -
                </button>{" "}
                <button
                  style={{ width: "25px" }}
                  onClick={() => {
                    this.handleLayerBackgroundOpacity(
                      i,
                      this.state.Inputs[i].Opacity + 1
                    );
                  }}
                >
                  +
                </button>
              </div>
              */}
              <br />
              <button
                style={{ margin: "5px" }}
                onClick={() => {
                  this.handleMoveLayerUp(i);
                }}
              >
                Move Layer Back
              </button>
              <button
                style={{ margin: "5px" }}
                onClick={() => {
                  this.handleMoveLayerDown(i);
                }}
              >
                Move Layer Forward
              </button>
              <button
                style={{ margin: "5px" }}
                onClick={() => this.handleDeleteLayer(i)}
              >
                Delete Layer
              </button>
              <br />
            </div>
          </div>
        );
      } else if (this.state.Inputs[i].LayerType == "Picture") {
        tempInputArray.push(
          <div className="InputTab">
            <div className="Controls">
              {i + 1 + ". "}
              Change Text
              <br />
              <input
                type="text"
                key={"input" + i}
                value={this.state.Inputs[i].Text}
                onChange={e => {
                  this.handleTextChange(i, e.target.value);
                }}
              />
              <br />
              Change Color
              <br />
              <input type="text" />
              <br />
            </div>
            <br />
          </div>
        );
      }
    }

    return tempInputArray;
  };

  //used to syncronize child and parent components
  callbackFunction = childData => {
    let tempInputs = this.state.Inputs;
    tempInputs[childData.index].Left = childData.left;
    tempInputs[childData.index].Top = childData.top;
    tempInputs[childData.index].Width = childData.width;
    tempInputs[childData.index].Height = childData.height;
    tempInputs[childData.index].RotateAngle = childData.rotateAngle;
    tempInputs[childData.index].ParentUpdate = false;

    this.setState({ Inputs: tempInputs, ParentUpdate: false });
  };

  //displays each layer
  displayLayers = () => {
    let tempLayerArray = [];
    for (let i = 0; i < this.state.Inputs.length; i++) {
      tempLayerArray.push(
        <Layer
          index={i}
          key={i}
          visible={this.state.Inputs[i].Visible}
          //text
          text={this.state.Inputs[i].Text}
          textColor={this.state.Inputs[i].TextColor}
          font={this.state.Inputs[i].Font}
          fontSize={this.state.Inputs[i].FontSize}
          fontWeight={this.state.Inputs[i].FontWeight}
          fontStyle={this.state.Inputs[i].FontStyle}
          textAlign={this.state.Inputs[i].TextAlign}
          textDecoration={this.state.Inputs[i].TextDecoration}
          lineHeight={this.state.Inputs[i].LineSpace}
          textOpacity={this.state.Inputs[i].TextOpacity}
          //background
          backgroundColor={this.state.Inputs[i].BackgroundColor}
          //opacity={this.state.Inputs[i].Opacity}
          opacity= {1}
          //position
          left={this.state.Inputs[i].Left}
          top={this.state.Inputs[i].Top}
          width={this.state.Inputs[i].Width}
          height={this.state.Inputs[i].Height}
          rotateAngle={this.state.Inputs[i].RotateAngle}
          //picture
          isImage={this.state.Inputs[i].IsImage}
          imageUrl={this.state.Inputs[i].ImageUrl}
          ratio={this.state.Inputs[i].Ratio}
          pictureOpacity={this.state.Inputs[i].PictureOpacity}
          //border
          borderThickness={this.state.Inputs[i].BorderThickness}
          borderColor={this.state.Inputs[i].BorderColor}
          //highlight
          highlight={this.state.Inputs[i].highlight}
          //callback to get child values
          parentsCallback={this.callbackFunction}
          parentUpdate={this.state.Inputs[i].ParentUpdate}
        />
      );
    }

    return tempLayerArray;
  };

  renderDesignToCanvas = async (includeProductTemplate) => {
    const canvas = document.createElement('canvas');
    const canvasSize = 1500; // High resolution square
    canvas.width = canvasSize;
    canvas.height = canvasSize;
    const ctx = canvas.getContext('2d');
    
    // Helper function to load image
    const loadImage = (src) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        
        // Only set crossOrigin for external URLs (not same-origin or data URLs)
        // This prevents canvas tainting issues with local images and base64 data
        if (src.startsWith('http://') || src.startsWith('https://')) {
          // Only set for external domains
          if (!src.includes(window.location.hostname)) {
            img.crossOrigin = 'anonymous';
          }
        }
        // For data URLs (base64) and local paths (/media/...), don't set crossOrigin
        
        img.onload = () => resolve(img);
        img.onerror = (err) => {
          console.error('Failed to load image:', src, err);
          reject(err);
        };
        img.src = src;
      });
    };
    
    if (includeProductTemplate) {
      // WITH BACKGROUND: Full composite showing final product
      
      // 1. Fill with background color if set
      if (this.state.BackgroundColor) {
        ctx.fillStyle = this.state.BackgroundColor;
        ctx.fillRect(0, 0, canvasSize, canvasSize);
      }
      
      // 2. Draw product base image (PictureUrl1)
      if (this.state.Product.PictureUrl1) {
        try {
          const baseImg = await loadImage(this.state.Product.PictureUrl1);
          ctx.drawImage(baseImg, 0, 0, canvasSize, canvasSize);
        } catch (e) {
          console.log('Failed to load base image:', e);
        }
      }
      
      // 3. Draw all user layers (text + images)
      await this.drawUserLayers(ctx, canvasSize, loadImage);
      
      // 4. Draw product overlay/template with hole (PictureUrl2)
      if (this.state.Product.PictureUrl2) {
        try {
          const overlayImg = await loadImage(this.state.Product.PictureUrl2);
          ctx.drawImage(overlayImg, 0, 0, canvasSize, canvasSize);
        } catch (e) {
          console.log('Failed to load overlay image:', e);
        }
      }
    } else {
      // TRANSPARENT CUTOUT: Design visible ONLY in the product shape (e.g., heart)
      // Everything outside the shape is transparent
      
      console.log('=== Creating Transparent Cutout ===');
      
      // Step 1: Draw user layers onto a temporary canvas
      const tempCanvas = document.createElement('canvas');
      tempCanvas.width = canvasSize;
      tempCanvas.height = canvasSize;
      const tempCtx = tempCanvas.getContext('2d');
      
      await this.drawUserLayers(tempCtx, canvasSize, loadImage);
      console.log('User layers drawn');
      
      // Step 2: If there's an overlay, use it as a mask
      if (this.state.Product.PictureUrl2) {
        try {
          console.log('Loading overlay:', this.state.Product.PictureUrl2);
          const overlayImg = await loadImage(this.state.Product.PictureUrl2);
          console.log('Overlay loaded:', overlayImg.width, 'x', overlayImg.height);
          
          // Create another temp canvas for the overlay
          const maskCanvas = document.createElement('canvas');
          maskCanvas.width = canvasSize;
          maskCanvas.height = canvasSize;
          const maskCtx = maskCanvas.getContext('2d');
          
          // Draw the overlay
          maskCtx.drawImage(overlayImg, 0, 0, canvasSize, canvasSize);
          
          // Get the image data
          const overlayData = maskCtx.getImageData(0, 0, canvasSize, canvasSize);
          const designData = tempCtx.getImageData(0, 0, canvasSize, canvasSize);
          const resultData = ctx.createImageData(canvasSize, canvasSize);
          
          // Count transparent vs opaque pixels to debug
          let transparentCount = 0;
          let opaqueCount = 0;
          let designPixelsInHole = 0;
          
          // Copy design pixels ONLY where overlay is transparent (the hole/shape)
          for (let i = 0; i < overlayData.data.length; i += 4) {
            const overlayAlpha = overlayData.data[i + 3];
            
            if (overlayAlpha < 128) {
              transparentCount++;
              // Overlay is transparent - show the design
              const designAlpha = designData.data[i + 3];
              if (designAlpha > 0) {
                designPixelsInHole++;
              }
              resultData.data[i] = designData.data[i];         // R
              resultData.data[i + 1] = designData.data[i + 1]; // G
              resultData.data[i + 2] = designData.data[i + 2]; // B
              resultData.data[i + 3] = designData.data[i + 3]; // A
            } else {
              opaqueCount++;
              // Overlay is opaque - leave transparent
            }
          }
          
          console.log('Overlay analysis:', { transparentCount, opaqueCount, total: transparentCount + opaqueCount });
          console.log('Percentage transparent:', (transparentCount / (transparentCount + opaqueCount) * 100).toFixed(2) + '%');
          console.log('Design pixels in transparent area:', designPixelsInHole);
          console.log('Percentage of hole filled with design:', (designPixelsInHole / transparentCount * 100).toFixed(2) + '%');
          
          ctx.putImageData(resultData, 0, 0);
          
        } catch (e) {
          console.error('Failed to create mask:', e);
          // Fallback: just draw the layers
          await this.drawUserLayers(ctx, canvasSize, loadImage);
        }
      } else {
        console.log('No overlay image, drawing layers only');
        // No overlay, just draw the layers
        await this.drawUserLayers(ctx, canvasSize, loadImage);
      }
    }
    
    return canvas;
  };

  drawUserLayers = async (ctx, canvasSize, loadImage) => {
    // Figure out the canvas offset and size from the current viewport
    const viewportCanvasSize = document.body.clientWidth > 600 
      ? document.body.clientWidth / 2 
      : 300;
    const viewportCanvasLeft = document.body.clientWidth > 600
      ? document.body.clientWidth / 2
      : document.body.clientWidth / 2 - 150;
    const viewportCanvasTop = document.body.clientWidth > 600
      ? 50
      : 10;
    
    const scaleRatio = canvasSize / viewportCanvasSize;
    
    console.log('Drawing', this.state.Inputs.length, 'user layers');
    console.log('Viewport canvas:', { viewportCanvasSize, viewportCanvasLeft, viewportCanvasTop, scaleRatio });
    
    for (let i = 0; i < this.state.Inputs.length; i++) {
      const layer = this.state.Inputs[i];
      console.log('Layer', i, 'original position:', { 
        hasImage: !!layer.ImageUrl, 
        hasText: !!layer.Text,
        Left: layer.Left,
        Top: layer.Top, 
        Width: layer.Width, 
        Height: layer.Height 
      });
      
      // Transform from screen coordinates to canvas coordinates
      // Subtract the canvas offset, then scale up
      const x = (layer.Left - viewportCanvasLeft) * scaleRatio;
      const y = (layer.Top - viewportCanvasTop) * scaleRatio;
      const w = layer.Width * scaleRatio;
      const h = layer.Height * scaleRatio;
      
      console.log('Layer', i, 'transformed:', { x, y, w, h });
      
      ctx.save();
      ctx.translate(x + w/2, y + h/2);
      ctx.rotate(layer.RotateAngle * Math.PI / 180);
      ctx.translate(-x - w/2, -y - h/2);
      
      // Draw layer background
      if (layer.BackgroundColor && layer.BackgroundColor !== 'rgba(255, 255, 255, 0)') {
        ctx.fillStyle = layer.BackgroundColor;
        ctx.fillRect(x, y, w, h);
      }
      
      // Draw image if exists
      if (layer.ImageUrl) {
        try {
          const layerImg = await loadImage(layer.ImageUrl);
          ctx.globalAlpha = layer.PictureOpacity / 100;
          
          // Check if ratio should be maintained (like in Layer.js)
          if (layer.Ratio) {
            // Maintain aspect ratio - only set width, let height scale naturally
            const aspectRatio = layerImg.naturalHeight / layerImg.naturalWidth;
            const naturalHeight = w * aspectRatio;
            ctx.drawImage(layerImg, x, y, w, naturalHeight);
          } else {
            // Stretch to fit layer box exactly
            ctx.drawImage(layerImg, x, y, w, h);
          }
          
          ctx.globalAlpha = 1;
        } catch (e) {
          console.log('Failed to load layer image:', e);
        }
      }
      
      // Draw text
      if (layer.Text) {
        ctx.fillStyle = layer.TextColor;
        ctx.font = `${layer.FontStyle} ${layer.FontWeight} ${layer.FontSize * scaleRatio}px ${layer.Font}`;
        ctx.textAlign = layer.TextAlign || 'center';
        ctx.globalAlpha = layer.TextOpacity / 100;
        
        const lines = layer.Text.split('\n');
        const lineHeight = layer.FontSize * scaleRatio * (layer.LineSpace / 100);
        lines.forEach((line, idx) => {
          let textX = x;
          if (layer.TextAlign === 'center') textX = x + w/2;
          else if (layer.TextAlign === 'right') textX = x + w;
          
          ctx.fillText(line, textX, y + (idx + 1) * lineHeight);
        });
        ctx.globalAlpha = 1;
      }
      
      // Draw border
      if (layer.BorderThickness > 0) {
        ctx.strokeStyle = layer.BorderColor;
        ctx.lineWidth = layer.BorderThickness * scaleRatio;
        ctx.strokeRect(x, y, w, h);
      }
      
      ctx.restore();
    }
  };

  downloadDesign = async () => {
    const productName = this.state.Product.Name.replace(/\s+/g, '_');
    const timestamp = Date.now();
    
    // Show loading message
    const loadingMsg = document.createElement('div');
    loadingMsg.style.cssText = 'position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);background:rgba(0,0,0,0.9);color:white;padding:30px 50px;border-radius:15px;z-index:10000;font-family:Montserrat,Arial;font-size:18px;text-align:center;';
    loadingMsg.innerHTML = '📦 Preparing your files...<br/><small style="font-size:14px;opacity:0.8;">This may take a few seconds</small>';
    document.body.appendChild(loadingMsg);

    try {
      // 1. Create JSON file
      let tempState = {};
      if (document.body.clientWidth > 600) {
        tempState.DashboardWidth = document.body.clientWidth / 2;
        tempState.DashboardLeft = document.body.clientWidth / 2;
        tempState.DashboardTop = 50;
      } else {
        tempState.DashboardWidth = 300;
        tempState.DashboardLeft = document.body.clientWidth / 2 - 150;
        tempState.DashboardTop = 10;
      }
      tempState.BackgroundColor = this.state.BackgroundColor;
      tempState.Inputs = this.state.Inputs;
      tempState.ProductId = this.state.Product.Id;
      tempState.ProductName = this.state.Product.Name;
      
      const designJSON = JSON.stringify(tempState, null, 2);
      this.downloadFile(designJSON, `${productName}_design_${timestamp}.json`, 'application/json');

      // 2. Render full mockup (with hand/holder)
      const canvasWithBg = await this.renderDesignToCanvas(true);
      canvasWithBg.toBlob((blob) => {
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${productName}_full_mockup_${timestamp}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      });

      // 3. Render product cutout (heart shape with design, no hand)
      const canvasNoBg = await this.renderDesignToCanvas(false);
      canvasNoBg.toBlob((blob) => {
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${productName}_cutout_${timestamp}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      });
      
      // Remove loading message and show success
      document.body.removeChild(loadingMsg);
      
      const successMsg = document.createElement('div');
      successMsg.style.cssText = 'position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);background:linear-gradient(135deg,#2ecc71,#27ae60);color:white;padding:30px 50px;border-radius:15px;z-index:10000;font-family:Montserrat,Arial;font-size:18px;text-align:center;box-shadow:0 8px 25px rgba(46,204,113,0.4);';
      successMsg.innerHTML = '✅ Success!<br/><small style="font-size:14px;opacity:0.9;">3 files downloaded:<br/>• Design JSON (editable data)<br/>• Full mockup (what it looks like finished)<br/>• Print template (design in heart shape only)</small>';
      document.body.appendChild(successMsg);
      
      setTimeout(() => {
        document.body.removeChild(successMsg);
      }, 4000);
      
    } catch (error) {
      document.body.removeChild(loadingMsg);
      alert('Error generating files: ' + error.message);
      console.error('Download error:', error);
    }
  };

  downloadFile = (content, filename, contentType) => {
    const blob = new Blob([content], { type: contentType });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  submitOrder = async () => {
    const { isDesignMode } = this.context;
    
    if (isDesignMode) {
      // In design mode, download the design instead
      this.downloadDesign();
    } else {
      // In live mode, submit to API
      let tempState = {};
      if (document.body.clientWidth > 600) {
        tempState.DashboardWidth = document.body.clientWidth / 2;
        tempState.DashboardLeft = document.body.clientWidth / 2;
        tempState.DashboardTop = 50;
      } else {
        tempState.DashboardWidth = 300;
        tempState.DashboardLeft = document.body.clientWidth / 2 - 150;
        tempState.DashboardTop = 10;
      }
      console.log(JSON.stringify(tempState));
      tempState.BackgroundColor = this.state.BackgroundColor;
      tempState.Inputs = this.state.Inputs;
      tempState.ProductId = this.state.Product.Id;

      let Values = JSON.stringify(tempState);
      
      await axios.post(
        "https://api.caigoycreations.com/projects/createprojectform",
          "=" + Values
      ).then(
        res => {
          window.location.href =
            "https://caigoycreations.com/products/view/" + res.data.data.GUID;
        },
        err => {
          alert("connection to api failed, please upload again" + err.data);
          console.log(err.data);
        }
      );
    }
  };

  checkStyle() {
    if (document.body.clientWidth < 600) {
      console.log("<");
      console.log(document.getElementsByClassName("Menu"));
      document.getElementById("Menu").style.display = "none";
    } else {
      console.log(document.getElementsByClassName("Menu"));
      document.getElementById("Menu").style.display = "flex";
    }
  }

  componentDidMount() {
    this.getProducts();
    this.checkStyle();
    window.addEventListener("resize", this.checkStyle);

    //add html background color
    // document.body.style.backgroundColor = '#3b4652';
    document.body.style.backgroundColor = '#FFFFFF';
    // document.body.style.backgroundImage = 'url("https://api.caigoycreations.com/content/img/wood.png")';
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.checkStyle);
    document.getElementById("Menu").style.display = "flex";

    //change html background color back
    //document.body.style.backgroundColor = '#FFF';
    document.body.style.backgroundImage = 'none';
  }



  render() {
    //window.scrollTo(0, 0);

    return (
      <div className='App'>
        <Menu2 />
        <div className="Dashboard">
          <Link to="/" className="Home">
            Home
          </Link>
          <div id="design-canvas-capture">
            <Background
              BackgroundColor={this.state.BackgroundColor}
              product={this.state.Product}
              grid={this.state.grid}
              gridPic={this.state.gridPic}
              safetyLine={this.state.safetyLine}
            />
            {this.displayLayers()}
          </div>
          <div className="DashboardSpacer"></div>
          <div className="Controls">
            <div className='Select-Product'>
              <label
                style={{fontFamily: 'Montserrat-bold'}}
              >Create <span style={{color: '#6c2c34'}}>Product</span></label>

              <select
                value={this.props.match.params.ID}
                onChange={e => {
                  this.handleProduct(e.target.value);
                }}
              >
                {this.state.ProductComponents}
              </select>

                {this.state.Product.Price &&
                  <div className='CreatePrice'>
                    <label>
                      ${this.state.Product.Price.toFixed(2)}
                    </label>
                    <br /><br />
                    <input 
                      type='checkbox' 
                      onClick={e => {
                        this.checkSafetyLine(e);
                      }}
                  />{' '}
                  Hide Safety Line
                  </div>
                  
                }

            </div>
            
            {this.state.Inputs.length === 0 && (
              <div className="getting-started-guide">
                <h3>🎨 Getting Started</h3>
                <ol>
                  <li><strong>Step 1:</strong> Choose a product from the dropdown above</li>
                  <li><strong>Step 2:</strong> (Optional) Select a background color for your design</li>
                  <li><strong>Step 3:</strong> Click "Add Layer" below to start designing</li>
                  <li><strong>Step 4:</strong> Upload images, add text, customize colors & fonts</li>
                  <li><strong>Step 5:</strong> When done, click "Download Design" to save!</li>
                </ol>
              </div>
            )}
            <div className="GridBox"
            style={{display: 'none'}}
            >
              <div className="GridLabel">Grid</div>
              <div className='Grid-Radios'>
                <div className='Grid-Single-Radio'>
                  <input
                    type="radio"
                    name="grid"
                    value="None"
                    onClick={() => this.handleGridPic("None")}
                  />
                  <label>None</label>
                </div>
              
                <div className='Grid-Single-Radio'>
                  <input
                    type="radio"
                    name="grid"
                    value="3"
                    onClick={() => {
                      this.handleGridPic(3);
                    }}
                  />
                  <label>3x3</label>
                </div>
                <div className='Grid-Single-Radio'>
                  <input
                    type="radio"
                    name="grid"
                    value="4"
                    onClick={() => {
                      this.handleGridPic(4);
                    }}
                  />
                  <label>4x4</label>
                </div>
                <div className='Grid-Single-Radio'>
                  <input
                    type="radio"
                    name="grid"
                    value="5"
                    onClick={() => {
                      this.handleGridPic(5);
                    }}
                  />
                  <label>5x5</label>
                </div>
              </div>
            </div>

            <div className='Background'>
                <button
                  onClick={() => {
                    this.setState({ ShowBGColor: !this.state.ShowBGColor });
                  }}
                  style={{marginRight: '10px'}}
                  
                >
                  {this.state.ShowBGColor &&
                    <div>Hide Color Picker</div>
                  }
                  {' '}
                  {!this.state.ShowBGColor &&
                    <div className='ButtonContent'>Select Background Color</div>
                  }
                </button>
                {' '}
                <button
                  onClick={() => {
                    this.backgroundColorChange('rgba(255, 255, 255, 0)')
                  }}
                   > Clear
                </button>
            </div>
            
            <br />
            {this.state.ShowBGColor && (
              <ColorPicker
                color={"#eeeeee"}
                onChange={e => {
                  this.backgroundColorChange(e);
                }}
                onConfirm={e => {
                  this.backgroundColorChange(e);
                }}
              />
            )}
            
            {this.displayInputTabs(0)}
            <br />
            <div className="AddButtons">
              <button
                onClick={() => {
                  this.addLayer("Text");
                }}
              >
                ➕ Add Layer
              </button>
              
              <br />
            </div>
            <br />
            <div className='Submit'>
              <button
                onClick={() => {
                  const { isDesignMode } = this.context;
                  const message = isDesignMode 
                    ? "Download your design? (3 files: JSON + 2 images)"
                    : "Are you sure you want to submit this project?";
                  if (window.confirm(message)) {
                    this.submitOrder();
                  }
                }}
              >
                {this.context && this.context.isDesignMode ? '📥 Download Design (3 Files)' : 'Submit Creation'}
              </button>
            </div>
          </div>{" "}
          {/* <!-- END OF CONTROLS --> */}
        </div>
      </div>
    );
  }
}

export default Create;
